export default "__VITE_ASSET__mYanK6ST__"